import { collectMediaIdsFromValue } from './collect-media-ids';
import { ALL_DUPLICATABLE_COLLECTIONS } from './constants';

import type { Payload } from 'payload';

const CONTENT_SCAN_BATCH_SIZE = 50;

/**
 * Scans all duplicatable source-tenant documents for media upload references.
 */
export const collectReferencedMediaIdsFromTenant = async (payload: Payload, sourceTenantId: string): Promise<Set<string>> => {
  const ids = new Set<string>();

  for (const slug of ALL_DUPLICATABLE_COLLECTIONS) {
    if (slug === 'media') continue;

    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const result = await payload.find({
        collection: slug as 'media',
        where: { tenant: { equals: sourceTenantId } },
        limit: CONTENT_SCAN_BATCH_SIZE,
        page,
        depth: 0,
        locale: 'all',
      });

      for (const doc of result.docs) {
        collectMediaIdsFromValue(doc, ids);
      }

      if (result.docs.length < CONTENT_SCAN_BATCH_SIZE) {
        hasMore = false;
      } else {
        page++;
      }
    }
  }

  return ids;
};
